import { authenticatedFetch } from '../../api/request';

export default async function getAppointmentHistory(setErrorMessage, status) {
    const onError = () => setErrorMessage('No se puede obtener el historial de citas.');
    return status ? await authenticatedFetch(`/appointment-user/history?idAppointmentStatus=${status}`, onError) : await authenticatedFetch('/appointment-user/history', onError);
}
